import { computed } from 'vue'
import { useQueries } from '@tanstack/vue-query'

import apis from '@/services'

export function useCheckMultipleAccommodations(accommodationIds, isBlockedCountry) {
  const campaignDataQueries = useQueries({
    queries: computed(() => {
      return accommodationIds.value.map(id => ({
        queryKey: ['campaignData', id],
        enabled: !!id && isBlockedCountry.value,
        queryFn: ({ queryKey }) => apis.rateConnect.fetchCampaign({ accommodationId: queryKey[1] }),
      }))
    }),
  })

  const partnersQueries = useQueries({
    queries: computed(() =>
      accommodationIds.value.map(id => ({
        queryKey: ['partners', id],
        enabled: !!id && isBlockedCountry.value,
        queryFn: ({ queryKey }) => apis.rateConnect.fetchPartners({ accommodationId: queryKey[1] }),
      }))
    ),
  })

  const accommodationsEligibility = computed(() => {
    return accommodationIds.value.map((id, index) => {
      const campaignQuery = campaignDataQueries.value[index]
      const partnersQuery = partnersQueries.value[index]

      const campaignData = campaignQuery?.data
      const partnersData = partnersQuery?.data || []
      const hasCampaign = campaignData?.status !== 204 && campaignData?.status === 200
      const hasEligiblePartner = partnersData.some(
        partner => partner.canNetCpa && partner.connectionStatus === 5 && partner.partnerStatus === 5
      )

      return {
        id,
        hasCampaign,
        isEligible: !hasCampaign && hasEligiblePartner,
        isLoading: campaignQuery?.isLoading || partnersQuery?.isLoading,
        isError: campaignQuery?.isError || partnersQuery?.isError,
      }
    })
  })

  const isLoading = computed(
    () => campaignDataQueries.value?.some(q => q.isLoading) || partnersQueries.value?.some(q => q.isLoading)
  )

  const isError = computed(
    () => campaignDataQueries.value?.some(q => q.isError) || partnersQueries.value?.some(q => q.isError)
  )

  return { accommodationsEligibility, isLoading, isError }
}
